import { type Mapper } from '@coris-ts/repository/mapper/mapper'
import { type MRRItemEntity } from '../../data/entities/mrr.entity'
import { type MRRData, type MRRResponse, DataType } from '../models/mrr'

export class MRREntityToMRRResponseMapper implements Mapper<MRRItemEntity[], MRRResponse> {
  public map(from: MRRItemEntity[]): MRRResponse {
    const data: MRRData[] = from.map((item) => ({
      date: item.date,
      data_type: item.data_type === 'economics' ? DataType.Economics : DataType.Users,
      new: item.new,
      existing: item.existing,
      churn: item.churn,
      total: item.total
    }))

    const metrics = {
      netNewMRR: from.map((item) => item.net_new),
      growthRate: from.map((item) => item.growth_rate),
      arr: from.map((item) => item.net_annually),
      lifetimeValue: from.map((item) => item.lifetime_value)
    }

    const dataType = from[0]?.data_type === 'economics' ? DataType.Economics : DataType.Users

    return {
      data,
      metrics,
      dataType
    }
  }
}
